import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API from "../config/API";

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:9777"
    : "http://192.168.0.2:9777";

export default function ExecutorList() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const adminLoginId = user?.adminId || user?.userId;

  const [executors, setExecutors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getExecutors();
  }, []);

  const getExecutors = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("user"));

      const response = await axios.get(
        `${API.V1}/head/getAllExecutorData/${adminLoginId}`,
        {
          headers: {
            Authorization: `Bearer ${user?.jwtToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.statusCode === 200) {
        setExecutors(response.data.data || []);
      } else {
        setExecutors([]);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.clear();
        alert("Session Expired. Please login again.");

        setTimeout(() => {
          navigate("/");
        }, 1000);

        return;
      }

      console.error(error);
      alert(error.response?.data?.message || "Unable to fetch executors.");
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (executorId, isActive) => {
    try {
      await axios.put(
        `${API_BASE_URL}/head/updateExecutorStatus/${executorId}`,
        {
          isActive: isActive,
        },
      );

      setExecutors((prev) =>
        prev.map((item) =>
          item.executorId === executorId
            ? { ...item, isActive: isActive }
            : item,
        ),
      );
    } catch (error) {
      console.error(error);
      alert("Unable to update executor status.");
    }
  };

  const handleEdit = (executorId) => {
    navigate("/createExecutor", {
      state: {
        executorId: executorId,
      },
    });
  };

  return (
    <div style={styles.container}>
      <div style={styles.headerContainer}>
        <h2 style={styles.heading}>Executors List</h2>

        <button
          style={styles.addButton}
          onClick={() => navigate("/createExecutor")}
        >
          + Add Executor
        </button>
      </div>

      {loading ? (
        <div style={styles.loading}>Loading...</div>
      ) : executors.length === 0 ? (
        <div style={styles.noData}>No Executors Available</div>
      ) : (
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>S.No</th>
                <th style={styles.th}>First Name</th>
                <th style={styles.th}>Last Name</th>
                <th style={styles.th}>Email</th>
                <th style={styles.th}>Mobile</th>
                <th style={styles.th}>Role</th>
                <th style={styles.th}>Work Location</th>
                <th style={styles.th}>Referral Id</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Created On</th>
                <th style={styles.th}>Action</th>
              </tr>
            </thead>

            <tbody>
              {executors.map((item, index) => (
                <tr key={item.executorId}>
                  <td style={styles.td}>{index + 1}</td>

                  <td style={styles.td}>{item.exeFirstName}</td>

                  <td style={styles.td}>{item.exeLastName}</td>

                  <td style={styles.td}>{item.exeEmailId}</td>

                  <td style={styles.td}>{item.exeContactNo}</td>

                  <td style={styles.td}>{item.roles}</td>

                  <td style={styles.td}>{item.workLocatedPlace}</td>

                  <td style={styles.td}>{item.refferId}</td>

                  <td style={styles.td}>
                    <div style={styles.radioContainer}>
                      <label style={styles.radioLabel}>
                        <input
                          type="radio"
                          name={`status-${item.executorId}`}
                          checked={item.isActive === true}
                          onChange={() => updateStatus(item.executorId, true)}
                        />
                        Active
                      </label>

                      <label style={styles.radioLabel}>
                        <input
                          type="radio"
                          name={`status-${item.executorId}`}
                          checked={item.isActive === false}
                          onChange={() => updateStatus(item.executorId, false)}
                        />
                        Inactive
                      </label>
                    </div>
                  </td>

                  <td style={styles.td}>
                    {item.createdOn
                      ? new Date(item.createdOn).toLocaleString()
                      : "-"}
                  </td>

                  <td style={styles.td}>
                    <button
                      style={styles.editButton}
                      onClick={() => handleEdit(item.executorId)}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
const styles = {
  container: {
    width: "96%",
    margin: "25px auto",
    background: "#ffffff",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
  },

  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },

  heading: {
    margin: 0,
    color: "#1565C0",
    fontSize: "28px",
    fontWeight: "700",
  },

  addButton: {
    background: "#2E7D32",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 18px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
  },

  tableContainer: {
    overflowX: "auto",
    borderRadius: "8px",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1200px",
  },

  th: {
    background: "#1976D2",
    color: "#fff",
    padding: "12px",
    textAlign: "left",
    fontSize: "15px",
    border: "1px solid #ddd",
    whiteSpace: "nowrap",
  },

  td: {
    padding: "12px",
    border: "1px solid #ddd",
    fontSize: "14px",
    color: "#333",
    verticalAlign: "middle",
  },

  radioContainer: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },

  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  },

  editButton: {
    background: "#FB8C00",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "8px 18px",
    cursor: "pointer",
    fontWeight: "600",
    transition: "0.3s",
  },

  loading: {
    textAlign: "center",
    padding: "40px",
    fontSize: "20px",
    color: "#1976D2",
    fontWeight: "600",
  },

  noData: {
    textAlign: "center",
    padding: "40px",
    fontSize: "18px",
    color: "#888",
  },
};
